import { render, staticRenderFns } from "./PrivateKeysFormGlobal.vue?vue&type=template&id=c09199c2&"
import script from "./PrivateKeysFormGlobal.vue?vue&type=script&lang=js&"
export * from "./PrivateKeysFormGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c09199c2')) {
      api.createRecord('c09199c2', component.options)
    } else {
      api.reload('c09199c2', component.options)
    }
    module.hot.accept("./PrivateKeysFormGlobal.vue?vue&type=template&id=c09199c2&", function () {
      api.rerender('c09199c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/global/PrivateKeysFormGlobal.vue"
export default component.exports